import { CalendarAdminPage } from '@features/calendar/components/CalendarAdminPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/admin/calendar')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Calendar',
        }
    }
})

function RouteComponent() {
    return <CalendarAdminPage />
}
